import { SET_WXCHAT_MSG_LIST, SET_WXCHAT_PAGE_TOTAL, SET_WXCHAT_PAGE_NUM } from './mutation-types'
import api from '@/api'

const state = {
  msgList: [],
  pageSize: 10,
  pageTotal: 0,
  pageNum: 1,
}

const mutations = {
  [SET_WXCHAT_MSG_LIST] (state, payload) {
    state.msgList = payload
  },
  [SET_WXCHAT_PAGE_TOTAL] (state, payload) {
    if (payload !== state.pageTotal) {
      state.pageTotal = payload
    }
  },
  [SET_WXCHAT_PAGE_NUM] (state, payload) {
    if (payload !== state.pageNum) {
      state.pageNum = payload
    }
  },
}

const actions = {
  // 获取微信回复列表
  async getWechatMsgList ({ commit, state }, payload) {
    try {
      const { data } = await api.userApi.getWechatMsgList({pageSize: state.pageSize, pageNum: payload})
      commit(SET_WXCHAT_MSG_LIST, data.items)
      commit(SET_WXCHAT_PAGE_TOTAL, data.total)
      commit(SET_WXCHAT_PAGE_NUM, payload)
      return data
    } catch (error) {
      console.log(error)
    }
  },
  // 新增微信回复
  async addWechatMsg ({ dispatch }, payload) {
    try {
      const data = await api.userApi.addWechatMsg(payload)
      dispatch('getWechatMsgList', 1)
      return data
    } catch (error) {
      console.log(error)
    }
  },
  // 编辑微信回复
  async updateWechatMsg ({ dispatch }, payload) {
    try {
      const data = await api.userApi.updateWechatMsg(payload)
      dispatch('getWechatMsgList', 1)
      return data
    } catch (error) {
      console.log(error)
    }
  },
  // 删除微信回复
  async deleteWechatMsg ({ dispatch }, payload) {
    try {
      const data = await api.userApi.deleteWechatMsg(payload)
      dispatch('getWechatMsgList', 1)
      return data
    } catch (error) {
      console.log(error)
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
